import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Ticket01 = function Ticket01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M10 8V7m0 5.5v-1m0 5.5v-1M5.2 4h13.6c1.1201 0 1.6802 0 2.108.218.3763.1917.6823.4977.874.874C22 5.5198 22 6.08 22 7.2v1.3c-1.933 0-3.5 1.567-3.5 3.5s1.567 3.5 3.5 3.5v1.3c0 1.1201 0 1.6802-.218 2.108a2 2 0 0 1-.874.874C20.4802 20 19.9201 20 18.8 20H5.2c-1.1201 0-1.6802 0-2.108-.218a2 2 0 0 1-.874-.874C2 18.4802 2 17.9201 2 16.8v-1.3c1.933 0 3.5-1.567 3.5-3.5S3.933 8.5 2 8.5V7.2c0-1.1201 0-1.6802.218-2.108a2 2 0 0 1 .874-.874C3.5198 4 4.08 4 5.2 4"
    })
  }));
};
export default Ticket01;